export const decodeJwtPayload = (token: string): object => {
  const [, payloadBase64] = token.split(".");
  const decodedPayload = atob(payloadBase64);

  return JSON.parse(decodedPayload);
};
